import { Outlet, Link } from 'react-router-dom'
import { Button, Layout, Row, Col, Flex } from 'antd'
import { LayoutFooter } from './components/LayoutFooter'
import i18n from '../i18n/setupLocalization'
import LocalizationKeys from '../i18n/LocalizationKeys'

const { Content } = Layout

export const AuthLayout: React.FC = () => (
  <Layout style={{ minHeight: '100vh', background: 'white' }}>
    <Content>
      <Row>
        <Col
          className="hide-mobile"
          md={8}
          sm={24}
          style={{
            background: "url('/assets/images/background.png') center / contain",
            height: '100vh',
          }}
        />
        <Col lg={16} xs={24} style={{ height: '100vh' }}>
          <Flex vertical style={{ height: '100%' }}>
            <Flex
              style={{
                width: '100%',
                height: 64,
                padding: 20,
              }}
              align="center"
              justify="space-between"
            >
              <Link to="/">
                <img
                  src="/assets/images/logos/regular/purple.png"
                  height={45}
                  alt="Logo"
                />
              </Link>
              <Link to="/auth/register">
                <Button type="primary">
                  {i18n.t(LocalizationKeys.Page.Register.Title)}
                </Button>
              </Link>
            </Flex>
            <Flex
              style={{
                flex: 1,
                overflow: 'auto',
                padding: 20,
              }}
              justify="center"
              align="center"
            >
              <Flex style={{ maxWidth: 400 }}>
                <Outlet />
              </Flex>
            </Flex>
          </Flex>
        </Col>
      </Row>
    </Content>
    <LayoutFooter />
  </Layout>
)
